import React, { useState } from 'react'
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  FormControlLabel,
  Checkbox,
  Alert,
  InputAdornment,
  IconButton,
  Link,
} from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'

export default function SignIn({ flash = {} }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setErrors({})

    const newErrors = {}
    if (!email) newErrors.email = 'E-Mail ist erforderlich'
    if (!password) newErrors.password = 'Passwort ist erforderlich'
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }

    setSubmitting(true)

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = '/login'

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const fields = {
      authenticity_token: csrfToken || '',
      'user[email]': email,
      'user[password]': password,
      'user[remember_me]': rememberMe ? '1' : '0',
    }

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h5" component="h1" fontWeight={700} gutterBottom>
          Okonomi HV
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Melden Sie sich bei Ihrem Konto an
        </Typography>

        {flash.alert && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {flash.alert}
          </Alert>
        )}
        {flash.notice && (
          <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
            {flash.notice}
          </Alert>
        )}

        <Paper elevation={2} sx={{ p: 4, width: '100%' }}>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              label="E-Mail"
              type="email"
              fullWidth
              margin="normal"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
              slotProps={{ htmlInput: { 'data-testid': 'email-input' } }}
            />
            <TextField
              label="Passwort"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              margin="normal"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!errors.password}
              helperText={errors.password}
              slotProps={{
                htmlInput: { 'data-testid': 'password-input' },
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  color="primary"
                  slotProps={{ input: { 'data-testid': 'remember-me-checkbox' } }}
                />
              }
              label="Angemeldet bleiben"
              sx={{ mt: 1 }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={submitting}
              sx={{ mt: 2, mb: 2 }}
              data-testid="sign-in-button"
            >
              {submitting ? 'Anmelden...' : 'Anmelden'}
            </Button>
            <Box sx={{ textAlign: 'center' }}>
              <Link href="/password/new" variant="body2" underline="hover" data-testid="forgot-password-link">
                Passwort vergessen?
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  )
}
